import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezmvshv988: FaireProductEntity = {
  token: "p_ezmvshv988",
  type: "product",
  name: "How to Draw Cute Farm Animals",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/bc98d1a8d0d4ba98df7d9f972ca78d0e50ab913372c90fe0ab0387bdeed404fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c54dbac6039b3851746e0433d41c43941e38ac209fe888dfc19f7347e2eca73.jpeg",
    "https://cdn.faire.com/fastly/43daf5462595fa3a96c213b01dfe96f2a649d4a24379b699ebd6757e6706d881.jpeg",
    "https://cdn.faire.com/fastly/5408da4ad11e782b68dcf5155fcee8ee136319e07b25693105a054b60f37b14a.jpeg",
    "https://cdn.faire.com/fastly/103de9e2ea4e9594aa9bac1276e3a69686ef7fcee3716211cd25437cfeb24771.jpeg",
    "https://cdn.faire.com/fastly/f9efce4ef71bda7deb3068ff6d681b11720d993afb60576ab9b273ae6a4f2b4e.jpeg",
    "https://cdn.faire.com/fastly/451194b2263d85f3db2b747a211c63d573ac6e61e298e122a4923fc8368af47e.jpeg",
    "https://cdn.faire.com/fastly/bc3779edcba6cfafa301253f2f32da2ce4405380600859d206fe7ade1773c8f8.jpeg"
  ],
  priceDollars: 7,
  description: "Enter Planet Cute—where you can make any drawing absolutely adorable! In the eighth installment of this bestselling series, budding artists of any age can learn to draw farm animals—and make it CUTE. It’s easy! Just pick up your pencils, pens, crayons, or gel markers and follow these step-by-step how-to sequences. Learn the basics of Japanese kawaii, which emphasizes simple, rounded shapes; faces with large eyes and sweet expressions; and personifying inanimate objects. This book features traditional farm animals like cows, chickens, horses, ducks, rabbits, barn cats, and llamas as well as cute orchards, farm buildings, farmers, and everything else you’d find on a farm!",
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:10.797Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
